<!-- Top Navbar Area -->
<nav class="navbar top-navbar" id="navbar">
    <div class="header-container d-flex justify-content-between align-items-center w-100">
        
        <!-- Left Side: Profile & Greeting -->
        <div class="header-left d-flex align-items-center">
            <div class="responsive-burger-menu d-block d-lg-none mr-3" (click)="toggleSidebar()" style="cursor: pointer;">
                <i class="bx bx-menu text-dark" style="font-size: 1.5rem;"></i>
            </div>
            
            <div class="profile-greeting d-flex align-items-center">
                <div class="profile-img-box mr-3">
                    <img src="assets/img/user1.jpg" alt="user" class="rounded-circle profile-img" onerror="this.src='assets/img/default-user.png'">
                </div>
                <div class="greeting-text d-flex flex-column">
                    <span class="welcome-text text-muted">Welcome,</span>
                    <span class="user-name font-weight-bold">{{data.UM_Full_Name || 'Admin User'}}</span>
                </div>
            </div>
        </div>

        <!-- Right Side: Search & Icons -->
        <div class="header-right d-flex align-items-center">
            
            <!-- Search Bar removed -->

            <!-- Icons -->
            <div class="icon-group d-flex align-items-center">
                <a href="javascript:void(0)" class="icon-btn" (click)="get_Home()">
                    <i class='bx bx-message-square-dots text-muted'></i>
                </a>

                <div class="nav-item dropdown notification-box">
                    <a routerLink="notification" class="icon-btn position-relative" role="button" data-toggle="dropdown">
                        <i class='bx bx-bell text-muted'></i>
                        <span class="badge badge-danger rounded-circle notification-badge" *ngIf="appservice.lenth > 0">
                            {{appservice.lenth}}
                        </span>
                    </a>
                </div>
                
                <!-- Logout Button -->
                <a href="javascript:void(0)" class="logout-btn ml-2" (click)="logout()" title="Logout">
                    <i class='bx bx-log-out'></i> Logout
                </a>
            </div>
            
        </div>

    </div>
</nav>
<!-- End Top Navbar Area -->

<div class="bottommenu-area border-top ng-star-inserted mshow" *ngIf="this.appservice.disp_mmenu==true" >
    <div class="sidemenu-body">
        <ul class="sidemenu-nav" style="width: 100%; text-align: center!important; padding: 0px!important;">
            <li (click)="get_Home()" routerlinkactive="active" class="nav-item active" style="float: left; width: 25%; align-items: center;"><a class="nav-link" style="padding: 2px 2px;"><span  class="icon"><i 
                            class="bx bx-grid-alt"></i></span><br ><span 
                        class="menu-title">Home</span></a></li>
            <li (click)="Bill()" routerlinkactive="active" class="nav-item" style="float: left; width: 25%; align-items: center;"><a class="nav-link" style="padding: 2px 2px;"><span  class="icon"><i 
                            class="bx bx-hotel"></i></span><br ><span 
                        class="menu-title">Bill Enty </span></a></li>
            <li (click)="Result()" routerlinkactive="active" class="nav-item" style="float: left; width: 25%; align-items: center;"><a class="nav-link" style="padding: 2px 2px;"><span  class="icon"><i
                             class="bx bx-notepad"></i></span><br ><span
                         class="menu-title">Result</span></a></li>

            <li (click)="search()" routerlinkactive="active" class="nav-item" style="float: left; width: 25%; align-items: center;"><a class="nav-link" style="padding: 2px 2px;"><span  class="icon"><i
                                      class="bx bx-search"></i></span><br ><span
                                  class="menu-title">Search</span></a></li>

        </ul>
    </div>
</div>


<!-- End Top Navbar Area -->